import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import styled from "styled-components";

export function AuthTextInput(props) {
    return (
        <StyledTextField
            variant="outlined"
            fullWidth
            inputProps={{ "data-testid": props["data-testid"] }}
            color="secondary"
            {...props}
        />
    );
}

const StyledTextField = styled(TextField)`
    && {
        margin-bottom: 1rem;
    }
`;

AuthTextInput.propTypes = {
    "data-testid": PropTypes.string
};
